module.exports = "https://cdn.realtymogul.com/static/media/icon_trackrecord.4e57790d.svg";